import { Routes } from '@angular/router';
import { TokenGuard } from 'src/app/shared/common/guards/token.guard';
import { entryGuard } from './guards/entry.guard';
import { exitGuard } from './guards/exit.guard';
import { stepGuard } from './guards/step.guard';
import { AddEmployerPage } from './pages/add-employer/add-employer.page';
import { AmountPage } from './pages/amount/amount.page';
import { ConfirmPage } from './pages/confirm/confirm.page';
import { EmployerPage } from './pages/employer/employer.page';
import { FailedPage } from './pages/failed/failed.page';
import { RegimeFundPage } from './pages/regime-fund/regime-fund.page';
import { ServiceErrorPage } from './pages/service-error/service-error.page';
import { SubscriptionFlowPage } from './pages/subscription-flow/subscription-flow.page';
import { SuccessPage } from './pages/success/success.page';

export const SUBSCRIPTION_ROUTES: Routes = [
  {
    path: 'suscripcion',
    component: SubscriptionFlowPage,
    canActivate: [TokenGuard],
    canDeactivate: [exitGuard],
    children: [
      { path: 'paso/1', component: AmountPage, canActivate: [entryGuard] },
      {
        path: 'paso/2',
        component: RegimeFundPage,
        canActivate: [stepGuard('amount')],
      },
      {
        path: 'paso/3',
        component: EmployerPage,
        canActivate: [stepGuard('amount', 'regimeFund')],
      },
      {
        path: 'paso-agregar-empleador/3',
        component: AddEmployerPage,
        canActivate: [stepGuard('amount', 'regimeFund')],
      },
      {
        path: 'paso/4',
        component: ConfirmPage,
        canActivate: [stepGuard('amount', 'regimeFund', 'employer')],
      },
    ],
  },
  { path: 'success', component: SuccessPage },
  { path: 'failed-subscription', component: FailedPage },
  { path: 'service-error', component: ServiceErrorPage },
];
